import { isLastDayOfMonth } from "date-fns";
import { createContext, useContext, useState, ReactNode } from "react";

interface LoaderContextType {
  isLoading: boolean;
  setIsLoading: (value: boolean) => void;
}

const LoaderContext = createContext<LoaderContextType | undefined>(undefined);

interface LoaderStateProps {
  children: ReactNode;
}

const LoaderState: React.FC<LoaderStateProps> = ({ children }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  return (
    <LoaderContext.Provider value={{ isLoading, setIsLoading}}>
      {children}
    </LoaderContext.Provider>
  );
};

const Loader: React.FC = () => {
  const context = useContext(LoaderContext);

  if (!context) {
    throw new Error("Loader must be used within a LoaderState");
  }


  return <>{context.isLoading ? <div className="loaderContainer"><div className="loader"></div></div> : null}</>;
};

export { LoaderContext, LoaderState, Loader };
